export default __webpack_public_path__ + "d930dcd931b490b606c62948ac5c63ff.png";